import './styles.css'

import React from 'react'

export default class Bookmark extends React.Component {
  render () {
    return <div>Bookmark</div>
  }
}
